/* eslint-disable no-useless-escape */
export const tagsRegExp = (value: string) => {
  const regExp = new RegExp(/^[\w\s\-\'™©®,]+$/);
  return regExp.test(value);
};

export const replaceHtmlLineBreaks = (text: string): string => text.replace(/<br\s*\/?>/gi, '\n');
